module.exports = __webpack_public_path__ + "img/my-reminder.2aaa9cea.svg";